// Disable scroll restoration on Chrome and other modern browsers
export const disableScrollRestoration = () => {
    if(window && 'scrollRestoration' in window.history){
        window.history.scrollRestoration = 'manual';
    }
} 

//clean up function
export const restoreScrollRestoration = () => {
    if(window && 'scrollRestoration' in window.history){
        window.history.scrollRestoration = 'auto';
    }
} 


// WEBPACK FOOTER //
// ./src/utils/DisableScrollRestoration.ts